module.exports = __webpack_public_path__ + "img/GENERAL-IGNIS-1.e3f484e4.jpg";